/**
 * Even search filter types
 */
export enum EventFilterType {
  COMMISSION_ID = <any>'commissionId',
  FUNDING_REFERENCE_ID = <any>'fundingReferenceId',
  PAYMENT_REFERENCE_ID = <any>'paymentReferenceId',
  DATE_RANGE = <any>'dateRange',
  DATE_AFTER = <any>'dateAfter',
  DATE_BEFORE = <any>'dateBefore',
  GUEST_NAME = <any>'guestName',
  COMPLETED = <any>'eventStatusCompleted',
  MISSING_AGENCY = <any>'eventStatusMissingAgency',
  PAYMENT_STATUS = <any>'paymentStatus'
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/event-filter-type-enum.ts